import styled from 'styled-components';
import { colors } from '../../../../../theme/theme';

export const ListContent = styled.div`  
    width: 100%;
    height: calc(100vh - 15em); 
    overflow-y: scroll;
`;

export const NotFound = styled.div`  
    width: 100%;
    height: calc(100vh - 15em); 
    text-align: center;
    vertical-align: center;
    font-size: 24px;
    margin-top: 25vh;
    color: ${colors.greyscale.grey};

    .iconNotFound{
        font-size: 14vh;
        color: ${colors.greyscale.grey2};
    }
`;